<template>
    <item :icon="icon" name="刷新" @click="onClick"/>
</template>

<script>
import icon from '../icons/refresh.svg'
import Item from './item'
export default {
    components: {
        Item
    },
    data () {
        return {
            icon,
            loading: false
        }
    },
    methods: {
        onClick () {
            this.$emit('click')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/framework/data-grid/toolbar/refresh.vue